/* fp-v2-complementary.js
   ───────────────────────────────────────────────────────────────────────────
   Bloc "Recommandé avec" de la buy box FP v2 (snippets/fp-v2-complementary-block).

   1) HYDRATATION
      L'objet Liquid `recommendations` n'est peuplé que sur une requête vers
      /recommendations/products. Au rendu de la page produit il est vide : le
      bloc sort en [hidden] et ce script va chercher son contenu via la Section
      Rendering API (?section_id=<fp-v2-main>&intent=complementary), isole le
      bloc correspondant dans la réponse (data-fpv2-block-id), puis l'injecte.
      Si Search & Discovery ne renvoie rien, le bloc reste masqué : jamais
      d'encadré vide dans la buy box.

   2) AJOUT PANIER
      On ne peut PAS utiliser <product-form> ici : le bloc est rendu à
      l'intérieur du {% form 'product' %} de la buy box, et les <form> imbriqués
      sont invalides en HTML. On POSTe donc sur /cart/add.js et on rejoue le
      comportement de assets/component-product-form.js : mise à jour du
      compteur panier, event `cart:added`, puis ouverture du tiroir (ou message
      "Added", ou redirection vers /cart) selon les réglages du thème lus sur
      #PageContainer.
*/
(function () {
  var ADDED_MS = 2000;

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function cartSettings() {
    var page = document.getElementById('PageContainer');
    return {
      action: page ? page.dataset.cartAction : null,
      type: page ? page.dataset.cartType : null
    };
  }

  // window.routes est posé par layout/theme.liquid et porte le préfixe de
  // locale du marché courant (/en-us/cart/add…) : ne jamais coder les URLs en dur.
  function route(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  function getCart() {
    return fetch(route('cart_url', '/cart') + '.js').then(function (res) { return res.json(); });
  }

  function updateCartCount(cart) {
    var indicator = document.querySelector('[data-cart-count-indicator]');
    if (!indicator) return;
    indicator.textContent = cart.item_count;
    indicator.classList.remove('hide');
  }

  /* Prévient le reste de la page qu'un article vient d'entrer dans le panier.
     `cart:added` est l'event interne du thème (compteur, etc.). Les events DOM
     qui suivent sont ceux que les apps de panier écoutent le plus couramment :
     on les émet tous, une app qui n'en connaît qu'un les ignore sans dommage. */
  function notifyCartChanged(cart) {
    var bus = window.eventBus;
    if (bus && typeof bus.emit === 'function') bus.emit('cart:added', {});

    ['cart:refresh', 'cart:updated', 'cart:change', 'cart:build'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart } }));
    });
  }

  /* ── Ajout panier ──────────────────────────────────────────────────── */
  function bindAddButtons(root) {
    var buttons = root.querySelectorAll('[data-fpv2-cr-add]');
    Array.prototype.forEach.call(buttons, function (btn) {
      if (btn.dataset.fpv2CrBound === 'true') return;
      btn.dataset.fpv2CrBound = 'true';
      btn.addEventListener('click', function () { addToCart(btn); });
    });
  }

  function toggleParts(btn, state) {
    var label   = btn.querySelector('[data-fpv2-cr-label]');
    var added   = btn.querySelector('[data-fpv2-cr-added]');
    var spinner = btn.querySelector('[data-fpv2-cr-spinner]');
    if (label)   label.hidden   = state !== 'idle';
    if (added)   added.hidden   = state !== 'added';
    if (spinner) spinner.hidden = state !== 'loading';
  }

  function addToCart(btn) {
    var variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;

    btn.disabled = true;
    toggleParts(btn, 'loading');

    // Requête calquée sur celle de component-product-form.js (l'ATC principale) :
    // corps FormData + X-Requested-With, PAS de JSON. Les apps de panier (Cartix
    // ici) interceptent les appels à /cart/add pour ouvrir leur tiroir, et leurs
    // intercepteurs reconnaissent la requête classique du thème — un corps JSON
    // passe souvent au travers.
    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');

    fetch(route('cart_add_url', '/cart/add') + '.js', {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: body
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return getCart();
      })
      .then(function (cart) {
        updateCartCount(cart);
        notifyCartChanged(cart);

        // Feedback dans le bouton dans tous les cas : si l'app de panier
        // n'ouvre pas son tiroir, l'ajout reste visible pour le client.
        toggleParts(btn, 'added');
        setTimeout(function () {
          toggleParts(btn, 'idle');
          btn.disabled = false;
        }, ADDED_MS);

        // Tiroir natif du thème : uniquement si le bloc le demande. Par défaut
        // on ne l'ouvre pas — sur une boutique équipée d'une app de panier
        // (Cartix), le forcer affichait le tiroir natif PAR-DESSUS / À LA PLACE
        // de celui de l'app. On laisse l'app réagir à l'appel /cart/add.
        var root = btn.closest('[data-fpv2-complementary]');
        if (!root || root.dataset.openThemeDrawer !== 'true') return;

        var settings = cartSettings();
        var bus = window.eventBus;
        if (settings.type === 'drawer' && bus && typeof bus.emit === 'function') {
          bus.emit('toggle:right:drawer', { type: 'cart', forceOpen: true, params: { cart: cart } });
        } else if (settings.type !== 'drawer') {
          window.location = route('cart_url', '/cart');
        }
      })
      .catch(function () {
        // Échec (rupture de stock entre-temps, réseau…) : on rend le bouton.
        toggleParts(btn, 'idle');
        btn.disabled = false;
      });
  }

  /* ── Hydratation du bloc ───────────────────────────────────────────── */
  function hydrate(el) {
    if (el.dataset.fpv2CrLoaded === 'true') return;
    el.dataset.fpv2CrLoaded = 'true';

    var url = el.dataset.url;
    if (!url) return;

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // La réponse contient toute la section fp-v2-main : on isole le bloc
        // par son id, sinon on retomberait sur un autre bloc complémentaire.
        var selector = '[data-fpv2-complementary][data-fpv2-block-id="' + el.dataset.fpv2BlockId + '"]';
        var fresh = doc.querySelector(selector) || doc.querySelector('[data-fpv2-complementary]');
        var hasItems = fresh && fresh.querySelector('.fp-v2-cr__item');

        if (!hasItems) {
          // Aucun produit complémentaire configuré : on ne le signale que dans
          // l'éditeur de thème, jamais en boutique.
          if (isDesignMode()) {
            el.innerHTML =
              '<div class="fp-v2-cr__box"><p class="fp-v2-cr__empty">Aucun produit complémentaire défini pour ce produit dans l’app Search &amp; Discovery. Le bloc est masqué en boutique.</p></div>';
            el.removeAttribute('hidden');
          }
          return;
        }

        el.innerHTML = fresh.innerHTML;
        el.removeAttribute('hidden');
        bindAddButtons(el);
      })
      .catch(function () {
        /* silencieux : le bloc reste masqué */
      });
  }

  function initAll(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('[data-fpv2-complementary]');
    Array.prototype.forEach.call(els, hydrate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor : re-render de la section → nouveau DOM à ré-hydrater.
  document.addEventListener('shopify:section:load', function (ev) { initAll(ev.target); });
})();
